import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ScholarshipTypeStoreActions,
  ScholarshipTypeStoreSelectors,
  ScholarshipTypeStoreReducer,
} from './index';
import { ScholarshipTypeDto } from '@cradua/data';

@Injectable()
export class ScholarshipTypeFacade {
  constructor(
    private store: Store<
      ScholarshipTypeStoreReducer.ScholarshipTypePartialState
    >
  ) {}

  scholarshipTypeRecord$ = this.store.select(
    ScholarshipTypeStoreSelectors.getSelected
  );
  scholarshipTypeRecordError$ = this.store.select(
    ScholarshipTypeStoreSelectors.getScholarshipTypeError
  );

  getselected() {
    return this.store.select(ScholarshipTypeStoreSelectors.getSelected);
  }

  get isLoadingScholarshipType() {
    this.store.dispatch(ScholarshipTypeStoreActions.loadScholarshipType());
    return this.store.select(
      ScholarshipTypeStoreSelectors.loadingScholarshipType
    );
  }

  get loadScholarshipType() {
    this.store.dispatch(ScholarshipTypeStoreActions.loadScholarshipType());
    return this.store.select(
      ScholarshipTypeStoreSelectors.getAllScholarshipType
    );
  }

  addScholarshipType(newScholarshipType: ScholarshipTypeDto[]) {
    this.store.dispatch(
      ScholarshipTypeStoreActions.addScholarshipType({ newScholarshipType })
    );
  }

  updateScholarshipType(updateScholarshipType: ScholarshipTypeDto[]) {
    this.store.dispatch(
      ScholarshipTypeStoreActions.updateScholarshipType({
        updateScholarshipType,
      })
    );
  }

  removeScholarshipType(ids: string[]) {
    this.store.dispatch(
      ScholarshipTypeStoreActions.removeScholarshipType({ ids })
    );
  }
}
